import React, { useEffect, useRef, useState } from 'react';
import { JOURNEY } from './content';
import './rcm.css';

const clamp = (n) => Math.min(Math.max(0, n), JOURNEY.length - 1);
const SWEEP_MS = 260; // per station when a frame change skips stations

// The claim's journey as a strip of eight stations; pick one and read what
// happens there, who does it, what goes wrong and which initiative touches
// it. `frame` = station index from ?fig=claim-journey&frame=. When the tour
// jumps more than one station (eligibility → the denial), the strip SWEEPS
// through the ones between at SWEEP_MS each, so the eye follows the claim
// down the line instead of seeing it teleport.
export default function ClaimJourney({ frame = null }) {
  const [i, setI] = useState(() => (frame != null ? clamp(frame) : 0));
  const iRef = useRef(i);
  iRef.current = i;
  useEffect(() => {
    if (frame == null) return undefined;
    const to = clamp(frame);
    const from = iRef.current;
    const reduce = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduce || Math.abs(to - from) <= 1) { setI(to); return undefined; }
    const dir = to > from ? 1 : -1;
    let cur = from;
    const t = setInterval(() => {
      cur += dir;
      setI(cur);
      if (cur === to) clearInterval(t);
    }, SWEEP_MS);
    return () => clearInterval(t);
  }, [frame]);
  const s = JOURNEY[i];
  return (
    <div className="as-screen rcm-journey" data-nova-note="The claim's journey from eligibility to cash; each station names what happens, who does it, what goes wrong, and which initiative touches it. Amber stations are where the money is lost.">
      <ol className="rcm-strip" aria-label="Stations of a claim">
        {JOURNEY.map((st, k) => (
          <li key={st.id} className={`tone-${st.tone} ${k === i ? 'on' : ''} ${k < i ? 'past' : ''}`}>
            <button type="button" onClick={() => setI(k)} aria-current={k === i ? 'step' : undefined}>
              <b>{st.label}</b>
              <small>{st.sub}</small>
            </button>
          </li>
        ))}
      </ol>
      <div className="rcm-station">
        <div className="rcm-station-head">
          <span className={`rcm-dot tone-${s.tone}`} aria-hidden="true" />
          <h3>{s.label} <span>· {s.sub}</span></h3>
          <span className="as-tabctl" role="group" aria-label="station controls">
            <button type="button" onClick={() => setI((i + JOURNEY.length - 1) % JOURNEY.length)} aria-label="previous station">‹</button>
            <button type="button" onClick={() => setI((i + 1) % JOURNEY.length)} aria-label="next station">›</button>
            <small>{i + 1} / {JOURNEY.length}</small>
          </span>
        </div>
        <dl className="rcm-kv">
          <div><dt>What happens</dt><dd>{s.what}</dd></div>
          <div><dt>Who does it today</dt><dd>{s.who}</dd></div>
          <div className="is-amber"><dt>What goes wrong</dt><dd>{s.wrong}</dd></div>
          <div className="is-teal"><dt>Where nventr touches it</dt><dd>{s.touch}</dd></div>
        </dl>
      </div>
    </div>
  );
}
